import { Group, Namespace, useTranslate } from "localization";
import { Button, Modal } from "minimum-ui/core";

export const ExitModal: React.FC<{
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  confirmationText?: string;
}> = ({ open, onClose, onConfirm, confirmationText }) => {
  const { translate } = useTranslate(Namespace.DEFAULT, Group.MODAL);

  return (
    <Modal
      isOpen={open}
      onDismiss={onClose}
      title={translate("exitTitle")}
      content={confirmationText ? confirmationText : translate("exitContent")}
      actions={
        <>
          <Button variant="outlined" onClick={onClose}>
            {translate("exitCancel")}
          </Button>
          <Button variant="contained" color="error" onClick={onConfirm}>
            {translate("exitConfirm")}
          </Button>
        </>
      }
    />
  );
};
